module.exports = "<app-navbar *ngIf=\"isAuth()\"></app-navbar>\n<app-sidenav *ngIf=\"isAuth()\"></app-sidenav>\n<router-outlet></router-outlet>\n"